import { ChainInfo } from "@keplr-wallet/types";
import { Eip1193Provider } from "ethers";
import {
  Address,
  Msg,
  Network,
  Signer,
  signers,
  Simulation,
  TxResult,
} from "rujira.js";
import { CosmosClient } from "rujira.js/src/signers/cosmos";
import { Eip712Signer } from "rujira.js/src/signers/cosmos/proto-signing";
import * as thor from "../config/thor";
import { buildClient, simulate } from "./cosmos";

interface Provider extends Eip1193Provider {
  on?: (event: string, cb: () => void) => any;
}

export class Eip712Adapter implements Signer {
  private chainInfo: ChainInfo =
    import.meta.env.MODE === "main" ? thor.main : thor.stage;
  constructor(private e: () => Provider | undefined) {}

  async connect(): Promise<Address[]> {
    const e = this.e();
    if (!e) throw new Error(``);
    const prefix = this.chainInfo.bech32Config?.bech32PrefixAccAddr;
    if (!prefix)
      throw new Error(
        `No bech32 prefix provided for ${this.chainInfo.chainId}`
      );
    const signer = new Eip712Signer(e, prefix, this.chainInfo.rpc);
    const accounts = await signer.getAccounts();
    return accounts.map((a) => a.address);
  }

  async simulate(msg: Msg): Promise<Simulation> {
    await this.e()?.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x1" }],
    });
    const client = await this.buildClient();
    return simulate(client, msg);
  }
  async signAndBroadcast(_simulation: Simulation, msg: Msg): Promise<TxResult> {
    const encoded = await msg.toCosmosTx();
    const client = await this.buildClient();
    const res = await client.signAndBroadcast(
      msg.account.address,
      encoded.msgs,
      "auto",
      encoded.memo
    );
    signers.cosmos.assertIsDeliverTxSuccess(res);
    return {
      network: msg.account.network,
      address: msg.account.address,
      txHash: res.transactionHash,
      deposited: msg.toDeposit ? msg.toDeposit() : undefined,
    };
  }

  public async buildClient(): Promise<CosmosClient> {
    const prefix = this.chainInfo.bech32Config?.bech32PrefixAccAddr;
    if (!prefix)
      throw new Error(
        `No bech32 prefix provided for ${this.chainInfo.chainId}`
      );
    const e = this.e();
    if (!e) throw new Error(`No EVM provider found`);
    const signer = new Eip712Signer(e, prefix, this.chainInfo.rpc);
    return buildClient(this.chainInfo, signer);
  }

  onChange?: ((cb: () => void) => void) | undefined;
  isAvailable() {
    return true;
  }
  disconnect?: (() => void) | undefined;
  public networks(): Network[] {
    return ["THOR"];
  }
}
